import { IEmployeeTimeOffMutations } from './mutations.types';
import {
  IEmployeeTimeOffBookingBalanceData,
  IEmployeeTimeOffData,
  IEmployeeTimeOffEntitlementData
} from '@/models';
import { IEmployeeTimeOffState } from '../employee-timeoff.types';

export const mutations: IEmployeeTimeOffMutations = {
  SET_EMPLOYEE_TIME_OFF_REQUEST_BALANCES(
    state: IEmployeeTimeOffState,
    payload: IEmployeeTimeOffBookingBalanceData[]
  ) {
    state.employeeTimeOffBalances = payload;
  },

  SET_LAST_PROMISE(state: IEmployeeTimeOffState, payload: Promise<any>): void {
    state.lastPromise = payload;
  },

  SET_EMPLOYEE_TIME_OFF_REQUEST(
    state: IEmployeeTimeOffState,
    payload: IEmployeeTimeOffData
  ): void {
    state.employeeTimeOff = payload;
  },

  SET_EMPLOYEE_TIME_OFF_REQUEST_ENTITLEMENTS(
    state: IEmployeeTimeOffState,
    payload: IEmployeeTimeOffEntitlementData[]
  ): void {
    state.employeeTimeOffEntitlements = payload;
  },

  SET_EMPLOYEE_TIME_OFF_REQUEST_ENTITLEMENT_YEARS(
    state: IEmployeeTimeOffState,
    payload: number[]
  ): void {
    state.employeeTimeOffEntitlementYears = payload;
  },

  SET_EMPLOYEE_TIME_OFF_REQUEST_ENTITLEMENT_VACATION_YEAR(
    state: IEmployeeTimeOffState,
    payload: number
  ): void {
    state.employeeTimeOffEntitlementVacationYear = payload;
  }
};
